export const NO_BREAK_SPACE = '\u00A0';
